namespace RioERP.Products {
    export namespace PacksService {
        export const baseUrl = 'Products/Packs';

        export declare function Create(request: Serenity.SaveRequest<PacksRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PacksRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PacksRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PacksRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListPacks(request: Serenity.ServiceRequest, onSuccess?: (response: Serenity.ListResponse<PacksRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Products/Packs/Create",
            Update = "Products/Packs/Update",
            Delete = "Products/Packs/Delete",
            Retrieve = "Products/Packs/Retrieve",
            List = "Products/Packs/List",
            ListPacks = "Products/Packs/ListPacks"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ListPacks'
        ].forEach(x => {
            (<any>PacksService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
